import zhHantLocale from './zhHant'
import ptLocale from './pt'

var locale = {
  'zh-hant': {
    ...zhHantLocale
  },
  pt: {
    ...ptLocale
  }
}

export default locale
